import React, { useMemo } from "react";
import { makeStyles } from "tss-react/mui";
import PropTypes from "prop-types";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { DATA_SOURCE } from "../../../../../util/Data/DataModeling";

const useStyles = makeStyles()((theme) => ({
  PanelTitle: {
    color: "#ed6c02",
    paddingTop: "5px",
  },
  list: {
    listStyleType: "disc",
    margin: "0",
    padding: 0,
    paddingLeft: 32,
    background: "#f0f0f0",
    maxHeight: "200px",
    overflow: "auto",
  },
  listItem: {
    display: "list-item",
    padding: 0,
  },
}));

const SecondStepComponent = ({ selectionApplyConfirmation }) => {
  const { classes } = useStyles();

  const { sources = [], entities = [] } = useMemo(() => selectionApplyConfirmation, [selectionApplyConfirmation]);
  return (
    <>
      {sources.length !== 0 && (
        <>
          <Typography className={classes.PanelTitle} sx={{ margin: 0, padding: 0 }}>
            {DATA_SOURCE.plural}
          </Typography>
          <List className={classes.list}>
            {sources.map(({ displayName, id }) => (
              <ListItem className={classes.listItem} key={id}>
                <ListItemText primary={displayName} />
              </ListItem>
            ))}
          </List>
        </>
      )}
      {entities.length !== 0 && (
        <>
          <Typography className={classes.PanelTitle} sx={{ margin: 0, padding: 0 }}>
            Entities
          </Typography>
          <List className={classes.list}>
            {entities.map(({ displayName, id }) => (
              <ListItem className={classes.listItem} key={id}>
                <ListItemText primary={displayName} />
              </ListItem>
            ))}
          </List>
        </>
      )}
      <div>
        <div>Based on your selection, the above-listed objects will be applied to the data warehouse.</div>
        <div style={{ fontStyle: "italic", fontWeight: "bolder" }}>
          Note: You might observe more objects than selected, as some of them may have inter-connected relations
        </div>
      </div>
    </>
  );
};

SecondStepComponent.propTypes = {
  selectionApplyConfirmation: PropTypes.object.isRequired,
};

export default SecondStepComponent;
